import { React, useEffect, useState, useRef } from "react";
import "./ViewCandidateNomination.css";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";

import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Select from "@mui/material/Select";
import TablePagination from "@mui/material/TablePagination";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import {
 fetchPOCUploadedIndividualList,
 setEnterpriseID,
 updateLoginUserName,
} from "../Redux/BussinessPOCSlice";
import { useMsal } from "@azure/msal-react";
import { setFilteredListTH } from "../Redux/THSlice";
const CssTextField = styled(TextField)({
 "& .MuiOutlinedInput-root": {
  borderRadius: "50px",
 },
});
const MyNominations = () => {
 const [selectedCourseCode, setSelectedCourseCode] = useState([]);
 const [courseList, setCourseList] = useState([]);

 const [page, setPage] = useState(0);
 const dispatch = useDispatch();
 const nominationList = useSelector((state) => state.poc.individualCourseList);
 const uniqueCourses = nominationList.reduce((unique, course) => {
  if (!unique.some((item) => item.courseName === course.courseName)) {
   unique.push({ courseName: course.courseName, code: course.courseCode });
  }
  return unique;
 }, []);
 const [userEnterpriseID, setuserEnterpriseID] = useState();
 //  const userEnterpriseID = useSelector((state) => state.poc.enterpriseID);
 const uploadedCoureList = useSelector((state) => state.poc.uploadedCourseList);
 const [rowsPerPage, setRowsPerPage] = useState(10);
 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 const [uniqueDatesForCourse, setUniqueDatesForCourse] = useState();
 const [isDateSelected, setIsDateSelected] = useState(false);
 const [selectedDate, setSelectedDate] = useState("");
 const [searchVal, setSearchVal] = useState("");

 const handleChangePage = (event, newPage) => {
  setPage(newPage);
 };
 const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
 };

 useEffect(() => {
  dispatch(fetchPOCUploadedIndividualList(userEnterpriseID));
 }, [userEnterpriseID]);
 const searchFunction = (e) => {
  setSearchVal(e.target.value);
  setPage(1);
 };
 useEffect(() => {
  if (activeAccount) {
   dispatch(updateLoginUserName(activeAccount.idTokenClaims.enterpriseID));
  } else {
   dispatch(updateLoginUserName(null));
  }
 }, [activeAccount]);
 useEffect(() => {
  if (activeAccount) {
   console.log("Active acocunt is", activeAccount.idTokenClaims.enterpriseID);
   setuserEnterpriseID(activeAccount.idTokenClaims.enterpriseID);
  } else {
   setuserEnterpriseID(null);
  }
 }, [activeAccount]);
 const theme = createTheme({
  typography: {
   fontFamily: "Graphik-Regular",
  },
 });
 const getCourseDates = (code) => {
  setSelectedCourseCode(code);
  const courseNameToUniqueDatesMap = nominationList.reduce((map, course) => {
   if (!map.has(course.courseCode)) {
    map.set(course.courseCode, new Set());
   }
   map.get(course.courseCode).add(course.startDate);
   return map;
  }, new Map());

  // Change this to the desired course name
  setUniqueDatesForCourse(Array.from(courseNameToUniqueDatesMap.get(code)));
  // let initailSessionDate = Array.from(courseNameToUniqueDatesMap.get(code))[0];
  // let courseList = [];
  // nominationList.map((item, i) => {
  //  if (item.courseCode == selectedCourseCode && item.startDate == initailSessionDate) {
  //   courseList.push(item);
  //  }
  // });
  // setCourseList(courseList);
  // console.log("uniqueDatesForCourse[0]", initailSessionDate);
 };
 const handleListFilter = (date) => {
  let courseList = [];
  nominationList.map((item, i) => {
   if (item.courseCode == selectedCourseCode && item.startDate == date) {
    courseList.push(item);
   }
  });
  setCourseList(courseList);

  //   setCourseList(filteredData);
  //   console.log("courseList", courseList);
 };
 let filteredData = courseList.filter((val, i) =>
  val.enterpriseID.toLowerCase().includes(searchVal.toLowerCase())
 );
 return (
  <ThemeProvider theme={theme}>
   <Stack
    direction={"row"}
    sx={{ margin: "20px 0px 20px 0px", display: "flex", justifyContent: "space-between" }}
    spacing={2}
   >
    {/* {isDateSelected && (
     <input
      type="search"
      value={searchVal}
      onChange={searchFunction}
      style={{ height: "30px" }}
     ></input>
    )} */}
    <Stack direction={"row"} spacing={1} justifyContent={"flex-start"}>
     <Box sx={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
      <Typography sx={{ fontSize: "14px" }}>Select Course Name:</Typography>

      <FormControl sx={{ m: 1, minWidth: 170 }} size="small">
       <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        displayEmpty
        sx={{
         border: "solid 2px #7500C0",

         color: "#7500C0",
         fontWeight: "500",
         padding: "0px !important",
         height: "50px !important",
        }}
        onChange={() => setSelectedDate("")}
       >
        {uniqueCourses.map((courseNames, i) => (
         <MenuItem
          sx={{ color: "#7500C0", fontSize: "12px" }}
          value={i}
          onClick={() => {
           getCourseDates(courseNames.code);
          }}
         >
          {courseNames.courseName}
         </MenuItem>
        ))}
       </Select>
      </FormControl>
     </Box>
     {uniqueDatesForCourse != undefined && uniqueDatesForCourse.length != 0 && (
      <Box sx={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
       <Typography sx={{ fontSize: "14px" }}>Select Start Date:</Typography>
       <FormControl sx={{ m: 1, minWidth: 170 }} size="small">
        <Select
         labelId="demo-simple-select-label"
         id="demo-simple-select"
         displayEmpty
         sx={{
          border: "solid 2px #7500C0",

          color: "#7500C0",
          fontWeight: "500",
          padding: "0px !important",
          height: "50px !important",
         }}
         value={selectedDate}
         onChange={(e) => {
          setSelectedDate(e.target.value);
         }}
        >
         {uniqueDatesForCourse.map((dates, i) => (
          <MenuItem
           sx={{ color: "#7500C0", fontSize: "12px" }}
           value={dates}
           onClick={() => {
            handleListFilter(dates);
            setIsDateSelected(true);
           }}
          >
           {dates}
          </MenuItem>
         ))}
        </Select>
       </FormControl>
      </Box>
     )}
    </Stack>
    {isDateSelected && (
     <Box
      justifyContent={"center"}
      className="text-filed-box"
      display="flex"
      alignItems={"center"}
     >
      <CssTextField
       placeholder="Search by Enterprise ID"
       id="outlined-start-adornment"
       sx={{ m: 1, width: "25ch", align: "center" }}
       value={searchVal}
       onChange={searchFunction}
       size="small"
       margin="dense"
       InputProps={{
        endAdornment: (
         <IconButton type="submit" sx={{ p: "10px" }} aria-label="search">
          <SearchIcon />
         </IconButton>
        ),
       }}
      />
     </Box>
    )}
   </Stack>

   {isDateSelected && (
    <Box className="upload_table">
     <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
       <TableHead>
        <TableRow>
         <TableCell align="center">Sl No</TableCell>
         <TableCell align="center">Enterprise ID</TableCell>

         <TableCell align="center">Course Name</TableCell>
         <TableCell align="center">Nominated For</TableCell>
         <TableCell align="center">Scheduled For</TableCell>
         <TableCell align="center">Status</TableCell>
        </TableRow>
       </TableHead>
       <TableBody>
        {filteredData != undefined &&
         filteredData.length != 0 &&
         filteredData.map((row, index) => (
          <TableRow key={row.Sno}>
           <TableCell align="center" scope="row">
            {index + 1}.
           </TableCell>
           <TableCell align="center" scope="row">
            {row.enterpriseID}
           </TableCell>
           <TableCell align="center">{row.courseName}</TableCell>
           <TableCell align="center">{row.startDate}</TableCell>
           <TableCell align="center">{row.scheduledDate}</TableCell>
           <TableCell align="center">
            {row.status == 1 ? (
             <div className="status_requested_viewnominationtable">
              <span>Waiting for Approval</span>
             </div>
            ) : row.status == 2 ? (
             <div className="status_approved_viewnominationtable">
              <span>Waiting for Batch Allocation</span>
             </div>
            ) : row.status == 3 ? (
             <div className="status_rejected_viewnominationtable_section">
              <span className="status_rejected_viewnominationtable">Rejected</span>
              <span className="reason_span">{row.reason}</span>
             </div>
            ) : row.status == 4 ? (
             <div className="status_scheduled_viewnominationtable">
              <span>Scheduled</span>
             </div>
            ) : row.status == 5 ? (
             <div className="status_waitlistes_viewnominationtable">
              <span>Rejected</span>
             </div>
            ) : null}
           </TableCell>
          </TableRow>
         ))}
       </TableBody>
      </Table>
     </TableContainer>
     <TablePagination
      className="upload_nomination_pagination"
      component="div"
      count={
       filteredData != undefined && filteredData.length != 0 ? filteredData.length : null
      }
      page={page}
      onPageChange={handleChangePage}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      sx={{
       width: "100% !important",
       visibility:
        filteredData != undefined && filteredData.length > 0 ? "visible" : "hidden",
      }}
     />
    </Box>
   )}
  </ThemeProvider>
 );
};

export default MyNominations;
